import generics from "./generics.json";
export const i18n = [];
i18n.push(generics);
